import React from 'react';
import { useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { coreUtils } from 'src/common';
import isNil from 'lodash/isNil';
import { Colors } from 'src/shared';
import Label from './Label';

const CategoryLabel = (props: { categoryId: number; [key: string]: any }) => {
  const { t } = useTranslation();

  const { categoryId, ...remainingProps } = props;
  const attributes = coreUtils.getAttributesByCatId(categoryId);
  const bg = useColorModeValue(attributes?.light, attributes?.dark);
  const color = useColorModeValue(Colors.light.whiteText, Colors.dark.whiteText);

  if (isNil(attributes)) return null;
  return (
    <Label
      color={color}
      bg={bg}
      label={t(attributes?.label as string)}
      minWidth="50px"
      rounded={4}
      {...remainingProps}
    />
  );
};

export default CategoryLabel;
